import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { useSecurity } from "../context/SecurityContext";
import { aiAllowance } from "../lib/api";
import { tr } from "../lib/i18n";

// Gentle note at 80%+ of today's AI allowance; upgrade link for owners, resets at midnight UTC.
export const AllowanceNudge = () => {
  const { member } = useSecurity();
  const { data } = useQuery({ queryKey: ["ai-allowance"], queryFn: aiAllowance, enabled: !!member, staleTime: 5 * 60_000, retry: false });
  if (!data || data.unlimited || data.pct < 80) return null;
  const full = data.pct >= 100;
  const isOwner = member?.role === "owner" || member?.role === "admin";
  return (
    <div data-testid="ai-allowance-nudge" className={`mb-4 flex flex-wrap items-center gap-x-3 gap-y-1 rounded-xl border px-4 py-2.5 text-sm ${full ? "border-amber-300 bg-amber-50 text-amber-900 dark:bg-amber-950/30 dark:text-amber-200" : "border-border bg-card text-muted-foreground"}`}>
      <Sparkles className="h-4 w-4 shrink-0 text-primary" />
      <span data-testid="ai-allowance-text">
        {full ? tr("Today's AI allowance is used up") : `${tr("You've used")} ${data.pct}% ${tr("of today's AI allowance")}`} ({data.used}/{data.limit}). {tr("Documents still save; AI filing resumes at")} {data.resets}.
      </span>
      {isOwner && data.plan !== "family" && <Link to="/pricing" className="text-primary hover:underline font-medium" data-testid="ai-allowance-upgrade">{tr("Upgrade for a larger allowance")} →</Link>}
    </div>
  );
};
